import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/**
 * CRA + react-snap ship a /404.html entry; Puppeteer crawls it during prerender.
 * A matching route removes the router warning and satisfies react-snap’s title check.
 */
export default function Snap404Page() {
  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>404 — Page not found | SamperLabs</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <main className="relative z-10 mx-auto max-w-lg px-4 pb-24 pt-32 text-white/80 sm:px-6">
        <h1 className="text-2xl font-semibold text-white">404</h1>
        <p className="mt-4 leading-relaxed">This page does not exist.</p>
        <Link to="/" className="mt-6 inline-block text-blue-400 underline-offset-2 hover:underline">
          Back to home
        </Link>
      </main>
    </>
  );
}
